import { useNavigate } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import LeftArrow from '@/common/assets/icons/arrowLeftIcon.svg?react';
import { BackwardHandlerType } from '@/common/types/LayoutTypes';

const OnlyBackHeader = ({ backwardHandler }: BackwardHandlerType) => {
  const navigate = useNavigate();
  const handleBackTrigger = () => {
    backwardHandler ? backwardHandler() : navigate(-1);
  };
  return (
    <Box maxW="maxContainer" mx={'auto'} pos="relative" height={66}>
      <Box
        pos="absolute"
        right={0}
        top={5}
        padding={16}
        onClick={handleBackTrigger}
      >
        <LeftArrow />
      </Box>
    </Box>
  );
};

export default OnlyBackHeader;
